import { data } from "react-router-dom";
import { create } from "zustand";

const useDictionaryStore = create((set) => ({
  dictionary:{},
  fetchDictionaryData:async()=>{
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/dictionary`);
        if (!response.ok) {
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }
        const data = await response.json();
        console.log("Fetched Dictionary:");
        set({dictionary:data.dictionary})
    } catch (error) {
        console.error("Failed to fetch dictionary:", error);
    }
  },
  updateDictionary: async(dictionaryData)=>{
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/dictionary`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(dictionaryData)
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        console.log("Dictionary updated successfully:", data.message);
        set({dictionary:data.dictionary})
    } catch (error) {
        console.error("Failed to update dictionary:", error);
    }
  },

}));

export default useDictionaryStore;
